// This file is made to make any call to store or read from localstorage
// so that we keep track of everything, and can change things or
// remove no longer used keys in the migrate function

// Constants for part hierarchy storage
const VIEW_STATE_PREFIX = 'partHierarchyViewState';

export default {
  migrate () {
    // Get all localStorage keys
    const keys = Object.keys(localStorage);

    // these are in indexedDb now
    const protosCacheKeys = [
      'partProtosCache',
      'partProtosCacheTimestamp',
      'partProtosCacheKey'
    ]

    // Filter keys matching the pattern "changeOrderViewState-"
    const keysToRemove = keys
      .filter(key => {
        if (key.startsWith('changeOrderViewState-')) return true
        if (key.startsWith('partHierarchyColumnOrder')) return true
        if (protosCacheKeys.includes(key)) return true
        return false
      })

    console.log('remove', keysToRemove)
    // Remove the matched keys
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
  },

  // Get the key for hierarchy view state
  getHierarchyViewStateKey(orgId: string, viewMemoryKey: string): string {
    return `${VIEW_STATE_PREFIX}::${orgId}::${viewMemoryKey}`;
  },

  // Helper functions for getting/setting hierarchy view state
  getHierarchyViewState(key: string) {
    try {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      console.error("Error reading hierarchy view state:", error);
      return null;
    }
  },

  setHierarchyViewState(key: string, state: any) {
    try {
      localStorage.setItem(key, JSON.stringify(state));
      return true;
    } catch (error) {
      console.error("Error saving hierarchy view state:", error);
      return false;
    }
  }
}